// extracted by mini-css-extract-plugin
export var container = "_50-0";
export var error = "_50-9";
export var label = "_50-5";
export var light = "_50-6";
export var md = "_50-3";
export var sm = "_50-2";
export var thin = "_50-8";
export var thinBold = "_50-7";
export var vertical = "_50-4";
export var xs = "_50-1";